import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'recharts';

const tickStyleLocal = { fontSize: 12, fill: 'var(--dashboard-active-chart-tick)' };

const AreaAxisTick = ({ labelFormatter = undefined, axisTickStyle = {}, payload, x = 0, y = 0, ...otherProps }) => {
  const formatter = labelFormatter || (text => text);

  return (
    <Text x={x} y={y} style={{ ...tickStyleLocal, ...axisTickStyle }} {...otherProps}>
      {formatter(payload.value, payload)}
    </Text>
  );
};

AreaAxisTick.propTypes = {
  labelFormatter: PropTypes.func,
  axisTickStyle: PropTypes.object,
  payload: PropTypes.shape({
    value: PropTypes.any
  }).isRequired,
  x: PropTypes.number,
  y: PropTypes.number
};

export default AreaAxisTick;
